// state generalParametrization
const state = {}

// getters
const getters = {}

// actions
const actions = {
  async getLastInformFulfillmentObligation({ commit, rootState }, year) {
    const url = `${process.env.VUE_APP_URL}/files/getLastInformFulfillmentObligation/${year}`
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + rootState.login.accessToken,
          'Cache-Control': 'no-cache',
        },
      })
      const elem = response.json()
      return elem
    } catch (error) {
      console.error(error + commit)
      return error
    }
  },
  async sendFlagAria({ commit, rootState }) {
    const url = `${process.env.VUE_APP_URL}/files/sendFlagAria`
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + rootState.login.accessToken,
          'Cache-Control': 'no-cache',
        },
      })
      const elem = response.json()
      return elem
    } catch (error) {
      console.error(error + commit)
      return error
    }
  },
  async getInfoAria({ commit, rootState }) {
    const url = `${process.env.VUE_APP_URL}/jobs/getStatusRefreshNoms`
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + rootState.login.accessToken,
          'Cache-Control': 'no-cache',
        },
      })
      const elem = response.json()
      return elem
    } catch (error) {
      console.error(error + commit)
      return error
    }
  },
}

// mutations
const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations,
}
